module.exports = __webpack_public_path__ + "img/discussions.e4258adf.svg";